export const formConfig = {
    name: 'deleteReasonDialog',
    fields: [
        {
            label: '客户名称',
            prop: 'customerNameList',
            rule: [
                { required: false, message: '客户名称不能为空', trigger: ['change', 'blur'] }
            ],
            span: 24,
            type: 'custom'
        },
        {
            label: '删除原因',
            prop: 'abandonReason',
            rule: [
                { required: true, message: '删除原因不能为空', trigger: ['change', 'blur'] }
            ],
            span: 24,
            type: 'custom'
        }
    ],
    height: 325
};
